import React from 'react';
import { employees } from '../mockdata';
import { Helmet } from "react-helmet";

const AboutPage = () => {
  return (
    <>
      <Helmet>
        <title>About Us | Milstone Associates</title>
        <meta name="description" content="Learn about Milstone Associates, our mission, vision, and team of experts in MEP design and supervision." />
        <meta property="og:title" content="About Us | Milstone Associates" />
        <meta property="og:description" content="Learn about Milstone Associates, our mission, vision, and team of experts in MEP design and supervision." />
        <meta property="og:image" content="/images/logo.webp" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://milestoneassociate.com/about" />
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://milestoneassociate.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "About Us",
                "item": "https://milestoneassociate.com/about"
              }
            ]
          }
        `}</script>
      </Helmet>
      <div className="min-h-screen bg-white flex flex-col items-center">
        {/* Top: Who We Are over Panoramic Image with White Overlay */}
        <div className="relative w-full h-80 md:h-[420px] lg:h-[520px] flex items-center justify-center mb-10">
          <img
            src="/images/aboutUsBg.webp"
            alt="About panoramic"
            className="absolute inset-0 w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-white/30" />
          <h1 className="relative z-10 text-3xl md:text-5xl font-extrabold text-gray-900 text-center drop-shadow-lg mb-1">
            Who We Are
          </h1>
        </div>
        {/* Main Content: About Text */}
        <div className="max-w-6xl w-full text-center mx-auto px-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-black">About Us</h2>
          <div className="mb-6 text-left">
            <p className="mb-2"><span className="font-bold">Founder:</span> Mr. Ali Haider</p>
            <p className="mb-2"><span className="font-bold">Certified Engineer:</span> Pakistan Engineering Council</p>
            <p className="mb-4"><span className="font-bold">Member:</span> Institute of Engineers Pakistan</p>
            <p className="mb-4">
              Milestone Associates is an emerging engineering firm and premier provider of multi dimensional electrical & mechanical consultancy services, specializing in Planning/Designing and project management services for a wide range of sectors. <br /><br />
              Our team is dedicated to delivering innovative, sustainable, and cost-effective solutions tailored to each client’s unique needs. We believe in building long-term relationships through integrity, technical excellence, and a commitment to quality. <br /><br />
              With a focus on continuous improvement and client satisfaction, we strive to exceed expectations on every project, ensuring reliable results and lasting value.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">High Rise Residential Buildings</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">High Rise Commercial Towers</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">Healthcare Facilities</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">Community Centers</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">Sport complex</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">Restaurants & Motels</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">Educational Institutes</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">Shopping Malls</span>
              <span className="bg-gray-100 rounded-full px-4 py-2 text-gray-800 text-base font-medium">Residential Projects</span>
            </div>
          </div>
        </div>



        {/* Our Employees Section */}
    <div className="w-full mt-16 mb-10">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 text-black">Our Members</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-6xl mx-auto px-12">
        {employees.map((emp, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-md overflow-hidden flex flex-col items-center p-4 transform transition-all duration-300 hover:shadow-xl hover:scale-105 hover:-translate-y-1"
          >
            <img
              src={emp.image}
              alt={emp.name}
              className="w-40 h-40 object-cover rounded-full mb-4 border-4 border-gray-100 shadow-sm"
            />
            <h3 className="text-xl font-semibold text-gray-800">{emp.name}</h3>
            <p className="text-gray-600 italic">{emp.designation}</p>
            <p className="text-gray-700 text-sm mt-1"><span className="font-semibold">Qualification:</span> {emp.qualification}</p>
            <p className="text-gray-700 text-sm"><span className="font-semibold">Experience:</span> {emp.experience}</p>
          </div>
        ))}
      </div>
    </div>


      {/* Our Vision Section */}
      <div className="w-full mt-16 mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6 text-black">Our Vision</h2>
        <p className="text-lg md:text-xl text-gray-800 leading-relaxed text-center max-w-4xl mx-auto mb-12">
          We are dedicated to promote sustainable, performance-oriented, and <span className="underline">high quality</span> design & construction methods on all leading projects. Integrity in design, connection to the client and balance in our corporate culture are integral to our destiny.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto px-12">
          <div className="flex flex-col items-center bg-white p-2 rounded shadow">
            <h3 className="text-xl font-semibold mb-4">Quality & Reliability</h3>
            <img src="/images/vision1.webp" alt="Quality & Reliability" className="w-full h-80 object-contain" />
          </div>
          <div className="flex flex-col items-center bg-white p-2 rounded shadow">
            <h3 className="text-xl font-semibold mb-4">Commitment</h3>
            <img src="/images/vision2.webp" alt="Commitment" className="w-full h-80 object-contain" />
          </div>
          <div className="flex flex-col items-center bg-white p-2 rounded shadow">
            <h3 className="text-xl font-semibold mb-4">Dedication</h3>
            <img src="/images/vision3.webp" alt="Dedication" className="w-full h-80 object-contain" />
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default AboutPage; 
